<template lang="pug">
	div.row
		div.col-5.pr-0
			nav

				ul.pagination.pagination-sm

					li.page-item(v-if='showPrevious()', :class="{ 'disabled' : currentPage <= 1 }")
						a.page-link(href='#', v-if='currentPage <= 1')
							span {{ config.previousText }}

						a.page-link(href='#', v-if='currentPage > 1 ', @click.prevent='changePage(currentPage - 1)')
							span {{ config.previousText }}

					li.page-item(v-for='page in pages', :class="{ 'active': page === currentPage }")
						a.page-link(href='#', @click.prevent='changePage(page)') {{ page }}

					li.page-item(v-if='showNext()', :class="{ 'disabled' : currentPage === lastPage || lastPage === 0 }")
						a.page-link(href='#', v-if='currentPage === lastPage || lastPage === 0')
							span {{ config.nextText }}

						a.page-link(href='#', v-if='currentPage < lastPage', @click.prevent='changePage(currentPage + 1)')
							span {{ config.nextText }}
		div.col-7.pl-0
			small.text-muted Exibindo {{initialInterval}}-{{finalInterval}} de {{total}}

				

</template>

<script>

export default {

	name: 'paginacao',

	props: {
		total: {
			type: Number,
			required: true
		},
		
		pageSize: {
			type: Number,
			required: true
		},
		
		onChange: {
			type: Function,
			required: true
		},
		
		options: {
			type: Object
		}
	},

	data () {
		return {
			currentPage: 1
		};
	},

	computed: {

		lastPage () {
			
			let total = this.total / this.pageSize;
			
			if (total < 1) {
			
				return 1;
			}

			if (total % 1 !== 0) {

				return parseInt(total + 1);
			}

			return total;
		},

		pages () {

			let from = this.currentPage - this.config.offset;

			if (from < 1) {

				from = 1;
			}

			let to = from + (this.config.offset * 2);

			if (to >= this.lastPage) {

				to = this.lastPage;
			}

			let arr = [];

			while (from <= to) {

				arr.push(from);
				from++;
			}

			return arr;
		},
		
		config () {
			return Object.assign({
				offset: 2,
				previousText: '«',
				nextText: '»'
			}, this.options);
		},

		initialInterval () {
			
			if (this.currentPage === 1) {
				return 1;
			}

			return ((this.currentPage - 1) * this.pageSize) + 1;
		},

		finalInterval () {

			let value = this.currentPage * this.pageSize;

			return value > this.total ? this.total : value;
		}
	},

	methods: {

		showPrevious () {
			return this.config.alwaysShowPrevNext || this.currentPage > 1;
		},

		showNext () {
			return this.config.alwaysShowPrevNext || this.currentPage < this.lastPage;
		},

		changePage (page) {
			
			if (this.currentPage === page) return;
			
			this.setPage(page);
			
			this.onChange(page);
		},

		setPage (page) {

			this.currentPage = page;
		}
	}
};

</script>

<style lang="scss" scoped>

.count-info {
	font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// Paginacao.vue?22c33ebe